module.exports = __webpack_public_path__ + "static/out-of-office-cc1521b030cdb9fff93e779392295623.jpg";